// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"63e8822e","191":"63e8822e","814":"9c0c0229","927":"bd26c921"}[chunkId] + ".chunk.css";
};